import SkeletonCore from "@mui/material/Skeleton";
import type { SkeletonProps } from "@mui/material/Skeleton";
import type { ReactNode } from "react";

export const Skeleton: (props: SkeletonProps) => ReactNode = SkeletonCore;
